import { createRouter } from '@tanstack/react-router';

import { queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';

/**
 * Router de la aplicación.
 *
 * `auth` se rellena en `main.tsx` al montar `<RouterProvider context={{ auth }}>`;
 * aquí queda declarado para que `beforeLoad` tenga el tipo correcto.
 */
export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
